module.exports = {"imgsR":["/assets/img/g/g-r1.png","/assets/img/g/g-r2.png","/assets/img/g/g-r1.png"],"imgsC":["/assets/img/g/g-1.png","/assets/img/g/g-2.png","/assets/img/g/g-3.png","/assets/img/g/g-4.png","/assets/img/g/g-5.png","/assets/img/g/g-6.png","/assets/img/g/g-1.png","/assets/img/g/g-2.png"]}


//////////////////
// WEBPACK FOOTER
// ./src/components/GalleryMobile/imgs.json
// module id = 282
// module chunks = 0